import { io } from "socket.io-client";
import { getItem } from "../utility/localStorageControl";
const userDetails = getItem("userDetails");
const userId = userDetails?._id;
// export const socket = io("http://localhost:4001", { transports: ["polling"] });
export const qrSocket = io("https://api.posease.com/", {
  // transports: ["websocket"],
  // transports: ["websocket"],
  // upgrade: true,
  // path: "/socket.io/", // Explicit path helps with Cloudflare routing
  // reconnection: true,
  // reconnectionAttempts: Infinity,
  // reconnectionDelay: 1000,
  // reconnectionDelayMax: 5000,
  // randomizationFactor: 0.5,
  // auth: { userid: userId },
  // // Cloudflare-specific options
  // secure: true,
  // rejectUnauthorized: false, // Only for development/testing
  // // Debugging
  // debug: true,
});
